import { useWorkersBySowIDQuery } from "services/input-core/workers/get-all-workers-by-sowid";

import WorkersRelatedTable from "./WorkersRelatedTable/WorkersRelatedTable";
import { memo } from "react";

type WorkersRelatedProps = {
  sowID: string;
};

const WorkersRelated = memo(function WorkersRelated({
  sowID,
}: WorkersRelatedProps) {
  const { data: workersData, isLoading } = useWorkersBySowIDQuery(sowID);

  return (
    <WorkersRelatedTable
      isLoading={isLoading}
      data={workersData}
      data-cy="workers-related-table"
    />
  );
});

export default WorkersRelated;
